<script>
import Vue from 'vue';
import tasks from '@/content/services/TaskScheduler/Tasks';
import schedules from '@/content/services/TaskScheduler/Schedules';
import { mapFieldsTask, mapFieldsHealth } from '@/store/mapFields';

import { TASKS_REQUEST_TASK } from '@/store/actions/tasks';
import { ROUTE_API_CLEAR_TASK_SCHEDULER } from '@/constants/apiRoutes';

export default {
  name: 'TaskSchedulerMixon',
  props: {},

  computed: {
    ...mapFieldsTask(['completedTasks', 'currentTaskId', 'tasksLoaded']),
    ...mapFieldsHealth(['healthUuid']),

    /**
     * Alle Aufgaben sind erledigt.
     * Es gibt nichts mehr zu tun
     */
    allTasksAreDone() {
      return this.relevantTasksAreDone && this.hasTask('P3-10') && this.hasTask('P4-10');
    },

    relevantTasksAreDone() {
      return this.hasTask('P4-20') && this.hasTask('P4-30');
    },

    /**
     * Der Aufgabenbreich ist unterteilt in relevante Tasks (oben)
     * und optionale Tasks (unten).
     * Diese Funktion gibt alle revelanten Tasks aus.
     */
    relevantTasks() {
      let currentSchedules = [];
      currentSchedules = schedules[this.currentTaskId].visibleTasks.relevant;

      /**
       * SONDERFALL für P1-70!
       * In der Nein-Strecke von "Pflegebedürftigkeit erkennen" [P1-10]:
       * [P1-70], [P1-80], [P2-10]
       *
       * Ansonsten:
       * [P1-70], [P1-80]
       *
       * Also:
       * Wenn der aktuell Task P1-70 ist und der letzte Task bei den schon
       * erledigten Tasks P1-10, P1-80 oder P1-70 ist, sind wie in der "nein"-Stecke ->
       * Wir fügen also P2-10 hinzu.
       */
      if (this.currentTaskId === 'P1-70' && this.completedTasks.length > 0) {
        const lastTaskId = this.completedTasks[this.completedTasks.length - 1].taskId;
        if (lastTaskId === 'P1-10' || lastTaskId === 'P1-80' || lastTaskId === 'P1-70') {
          if (!currentSchedules.includes('P2-10')) {
            currentSchedules[currentSchedules.length] = 'P2-10';
          }
        }
      }
      /** SONDERFALL ende */

      return this.getItems(currentSchedules);
    },

    /**
     * Diese Funktion gibt alle optionalen Tasks aus.
     */
    optionalTasks() {
      const currentSchedules = schedules[this.currentTaskId].visibleTasks.optional;
      return this.getItems(currentSchedules || []);
    },

    /**
     * Diese Funktion gibt alle Ausgaben zurück, die zum aktuellen Zeitpunkt
     * angezeigt werden müssen.
     * Dazu werden die schon erledigten Task herangezogen, die sich im Store befinden (completedTasks)
     */
    visibleTasks() {
      const visibleTasks = [];
      tasks.map((task, i) => {
        const checked = this.completedTasks.filter((ct) => ct.taskId === task.taskId).length > 0;
        visibleTasks.push({
          ...task,
          checked,
        });

        if (task.subTasks) {
          task.subTasks.map((subTask, k) => {
            const checked =
              this.completedTasks.filter((ct) => ct.taskId === subTask.taskId).length > 0;
            visibleTasks[i].subTasks[k] = {
              ...subTask,
              checked,
            };
          });
        }
      });
      return visibleTasks;
    },

    /**
     * Im oberen Bereich gibt es die Goal Komponente, die den aktuellen Status
     * der Aufgaben visualisiert. Diese Komponente hat drei Stati und werden in dieser
     * Funktion bestimmt.
     * Im Figma Design wird deutlich, in welcher Phase welcher Status angezeigt wird.
     */
    taskGoalsVariant() {
      const phase = this.currentTaskId.split('-')[0];
      if (phase === 'P3') {
        return 1;
      }

      if (phase === 'P4') {
        return 2;
      }

      return 0;
    },
  },

  created() {
    if (this.completedTasks.length === 0) {
      this.$store.dispatch(TASKS_REQUEST_TASK);
    }
  },

  methods: {
    hasTask(taskId) {
      return this.completedTasks.filter((ct) => ct.taskId === taskId).length > 0;
    },

    getItems(currentSchedules) {
      const items = [];
      currentSchedules.map((cs) => {
        const match = this.visibleTasks.filter((t) => t.taskId === cs);
        if (match.length > 0) {
          items.push(match[0]);
        }
      });
      return items;
    },

    __resetTasks() {
      Vue.axios.post(ROUTE_API_CLEAR_TASK_SCHEDULER, { uuid: this.healthUuid }).then((response) => {
        const { status } = response;
        if (status === 200) {
          this.$router.go(this.$router.currentRoute);
        }
      });
    },
  },
};
</script>
